import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { TicketsSelector } from './ticketsSelector.component';
import { selectCurrentExperience } from '../../../../modules/experience';
import { selectBookingPrice } from '../../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  experience: selectCurrentExperience,
  totalPrice: selectBookingPrice,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(TicketsSelector);
